import { FC, PropsWithChildren } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import { useNewUiContext } from '@savgroup-front-common/core/components/NewUiProvider/NewUiProvider';
import { useGetControlTheme } from '@savgroup-front-common/core/theme/Theme';

export const ThemeProvider: FC<PropsWithChildren<any>> = ({ children }) => {
  const { isDarkModeEnabled } = useNewUiContext();

  const theme = useGetControlTheme({}, isDarkModeEnabled);

  return <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>;
};
